import { validateBirthDate, validateCpf } from '@jusbrasil-web/shared-utils-validators'

import { Nullable } from './types'

interface Spec {
  isValid: (value: Nullable<string>) => boolean
  message: string
}

export type ValidationSpecs = Spec[]

export const validateSpec = (specs: ValidationSpecs, value: string) =>
  specs.find(({ isValid }) => !isValid(value))

export const CPF_VALIDATIONS: ValidationSpecs = [
  { isValid: (value: Nullable<string>) => Boolean(value?.trim()), message: 'O CPF é obrigatório' },
  {
    isValid: (value: Nullable<string>) => validateCpf(value || ''),
    message: 'Insira um CPF válido',
  },
]

export const BIRTHDATE_VALIDATIONS: ValidationSpecs = [
  {
    isValid: (value: Nullable<string>) => Boolean(value?.trim()),
    message: 'A data de nascimento é obrigatória',
  },
  {
    isValid: (value: Nullable<string>) => validateBirthDate(value || ''),
    message: 'Insira uma data válida',
  },
]
